import { common } from "../endpoints/common.endpoints";
import $axios from "../http/accessor";

const CommonService = {
  contact: (data: FormData) => {
    return $axios.post(common.contact, data);
  },

  subscribe: (data: FormData) => {
    return $axios.post(common.subscribe, data);
  },
};

export default CommonService;
